// import * as firebase from 'firebase';
import firebase from 'firebase'

// Optionally import the services that you want to use
import "firebase/auth";
//import "firebase/database";
import "firebase/firestore";
//import "firebase/functions";
//import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCH86frjSeiorNZhToiYBPyiGmAJcD5bi8",
  authDomain: "ideafy-31536.firebaseapp.com",
  projectId: "ideafy-31536",
  storageBucket: "ideafy-31536.appspot.com",
  messagingSenderId: "433105140905",
  appId: "1:433105140905:web:7c0b7ebcb8bef99e4d3db8",
  measurementId: "G-CRW2Z4YHH8"
  };
  



const Firebase =  firebase.initializeApp(firebaseConfig); 
// firebase.initializeApp(firebaseConfig);

export default Firebase